/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Translation_Options_HeadingInputs */



/**
* | output |
* | --- |
* | "Translation Options" |
*
* @param {Edit_Event_Group_Translation_Options_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_translation_options_heading = /** @type {((inputs?: Edit_Event_Group_Translation_Options_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Translation_Options_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de tradução")
	return /** @type {LocalizedString} */ ("Translation Options")
});